import { format, isValid, parse } from 'date-fns'

const ISO_DAY = 'yyyy-MM-dd'

/** Formats an ISO day (yyyy-MM-dd) with the given display pattern; empty when there is no valid day. */
export function isoToDisplayDate(iso: string | undefined, displayFormat: string): string {
  if (!iso) return ''
  const day = parse(iso, ISO_DAY, new Date())
  return isValid(day) ? format(day, displayFormat) : ''
}

/** Parses text typed with the display pattern into an ISO day; undefined unless it is a complete, real date. */
export function displayToIsoDate(text: string, displayFormat: string): string | undefined {
  const day = parse(text, displayFormat, new Date())
  // The round trip rejects partial matches such as a two-digit year read as year 26
  if (!isValid(day) || format(day, displayFormat) !== text) return undefined
  return format(day, ISO_DAY)
}
